import { BrowserRouter } from 'react-router-dom'
import { AppRoutes } from './router/index'
import { InterviewProvider } from './context/InterviewContext'
import { AuthProvider } from './context/AuthContext'
import { ProfileProvider } from './context/ProfileContext'
import { ConfirmProvider } from './context/ConfirmContext'
import { ToastContainer } from './components/ui/ToastContainer'


function App() {
  return (
    <BrowserRouter basename={__BASE_PATH__}>
      <InterviewProvider>
        <AuthProvider>
          <ProfileProvider>
            <ConfirmProvider>
              <AppRoutes />
              <ToastContainer />
            </ConfirmProvider>
          </ProfileProvider>
        </AuthProvider>
      </InterviewProvider>
    </BrowserRouter>
  )
}

export default App